module.exports = __webpack_public_path__ + "img/candle-quartz-4.54d85fe1.jpg";